<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">
      {{ $t("lockerDelivery.clientData") }}
    </h2>
    <hr />

    <div class="columns">
      <div class="column">
        <b-field :label="$t('lockerDelivery.name')" label-position="on-border">
          <b-input
            v-model="client.personalInfo.name"
            :placeholder="$t('lockerDelivery.clientNamePlaceholder')"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('lockerDelivery.personalId')"
          label-position="on-border"
        >
          <b-input
            v-model="clientPersonalId"
            :placeholder="$t('lockerDelivery.personalIdPlaceholder')"
            @input.native="
              clientPersonalId = formatPersonalId('clientPersonalId')
            "
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field :label="$t('lockerDelivery.email')" label-position="on-border">
          <b-input
            v-model="client.personalInfo.email"
            :placeholder="$t('lockerDelivery.emailPlaceholder')"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('lockerDelivery.cellphone')"
          label-position="on-border"
        >
          <b-input
            v-model="clientCellphone"
            :placeholder="$t('lockerDelivery.cellphonePlaceholder')"
            @input.native="formatCellphone('clientCellphone')"
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column is-3">
        <b-field
          :label="$t('lockerDelivery.isWheelchairUser')"
          label-position="on-border"
        >
          <div class="block" style="padding-top: 1rem;">
            <b-radio
              v-model="client.personalInfo.wheelchairUser"
              name="client.personalInfo.wheelchairUser"
              :native-value="true"
            >
              {{ $t("common.yes") }}
            </b-radio>
            <b-radio
              v-model="client.personalInfo.wheelchairUser"
              name="client.personalInfo.wheelchairUser"
              :native-value="false"
            >
              {{ $t("common.no") }}
            </b-radio>
          </div>
        </b-field>
      </div>

      <div class="column is-3 is-offset-3">
        <b-field
          :label="$t('lockerDelivery.sendEmail')"
          label-position="on-border"
        >
          <div class="block" style="padding-top: 1rem;">
            <b-radio
              v-model="client.sendEmail"
              name="client.sendEmail"
              :native-value="true"
            >
              {{ $t("common.yes") }}
            </b-radio>
            <b-radio
              v-model="client.sendEmail"
              name="client.sendEmail"
              :native-value="false"
            >
              {{ $t("common.no") }}
            </b-radio>
          </div>
        </b-field>
      </div>

      <div class="column is-3">
        <b-field
          :label="$t('lockerDelivery.sendSMS')"
          label-position="on-border"
        >
          <div class="block" style="padding-top: 1rem;">
            <b-radio
              v-model="client.sendSMS"
              name="client.sendSMS"
              :native-value="true"
            >
              {{ $t("common.yes") }}
            </b-radio>
            <b-radio
              v-model="client.sendSMS"
              name="client.sendSMS"
              :native-value="false"
            >
              {{ $t("common.no") }}
            </b-radio>
          </div>
        </b-field>
      </div>
    </div>
    <br />

    <div v-if="locker.lockerInfo.hasCourier">
      <h2 class="subtitle">
        {{ $t("lockerDelivery.courierData") }}
      </h2>
      <hr />

      <div class="columns">
        <div class="column">
          <b-field
            :label="$t('lockerDelivery.name')"
            label-position="on-border"
          >
            <b-input
              v-model="courier.personalInfo.name"
              :placeholder="$t('lockerDelivery.courierNamePlaceholder')"
            ></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field
            :label="$t('lockerDelivery.personalId')"
            label-position="on-border"
          >
            <b-input
              v-model="courierPersonalId"
              :placeholder="$t('lockerDelivery.personalIdPlaceholder')"
              @input.native="
                courierPersonalId = formatPersonalId('courierPersonalId')
              "
            ></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field
            :label="$t('lockerDelivery.email')"
            label-position="on-border"
          >
            <b-input
              v-model="courier.personalInfo.email"
              :placeholder="$t('lockerDelivery.emailPlaceholder')"
            ></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field
            :label="$t('lockerDelivery.cellphone')"
            label-position="on-border"
          >
            <b-input
              v-model="courierCellphone"
              :placeholder="$t('lockerDelivery.cellphonePlaceholder')"
              @input.native="formatCellphone('courierCellphone')"
            ></b-input>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column is-3 is-offset-6">
          <b-field
            :label="$t('lockerDelivery.sendEmail')"
            label-position="on-border"
          >
            <div class="block" style="padding-top: 1rem;">
              <b-radio
                v-model="courier.sendEmail"
                name="courier.sendEmail"
                :native-value="true"
              >
                {{ $t("common.yes") }}
              </b-radio>
              <b-radio
                v-model="courier.sendEmail"
                name="courier.sendEmail"
                :native-value="false"
              >
                {{ $t("common.no") }}
              </b-radio>
            </div>
          </b-field>
        </div>

        <div class="column is-3">
          <b-field
            :label="$t('lockerDelivery.sendSMS')"
            label-position="on-border"
          >
            <div class="block" style="padding-top: 1rem;">
              <b-radio
                v-model="courier.sendSMS"
                name="courier.sendSMS"
                :native-value="true"
              >
                {{ $t("common.yes") }}
              </b-radio>
              <b-radio
                v-model="courier.sendSMS"
                name="courier.sendSMS"
                :native-value="false"
              >
                {{ $t("common.no") }}
              </b-radio>
            </div>
          </b-field>
        </div>
      </div>
      <br />
    </div>

    <h2 class="subtitle">
      {{ $t("lockerDelivery.deliveryDetails") }}
    </h2>
    <hr />

    <div class="columns">
      <div class="column is-3">
        <b-field
          :label="$t('lockerDelivery.deliveryId')"
          label-position="on-border"
        >
          <b-input
            v-model="deliveryId"
            :placeholder="$t('lockerDelivery.deliveryId')"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('lockerDelivery.anyObservations')"
          label-position="on-border"
        >
          <b-input
            v-model="observations"
            :placeholder="$t('lockerDelivery.anyObservations')"
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns" v-if="!locker.lockerInfo.hasCourier">
      <div class="column">
        <b-field
          :label="$t('lockerDelivery.openDoorNow')"
          label-position="on-border"
        >
          <div class="block" style="padding-top: 1rem;">
            <b-radio
              v-model="openDoorNow"
              name="openDoorNow"
              :native-value="true"
            >
              {{ $t("common.yes") }}
            </b-radio>
            <b-radio
              v-model="openDoorNow"
              name="openDoorNow"
              :native-value="false"
            >
              {{ $t("common.no") }}
            </b-radio>
          </div>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('lockerDelivery.warnClientNow')"
          label-position="on-border"
        >
          <div class="block" style="padding-top: 1rem;">
            <b-radio
              v-model="warnClientNow"
              name="warnClientNow"
              :native-value="true"
            >
              {{ $t("common.yes") }}
            </b-radio>
            <b-radio
              v-model="warnClientNow"
              name="warnClientNow"
              :native-value="false"
            >
              {{ $t("common.no") }}
            </b-radio>
          </div>
        </b-field>
      </div>
    </div>

    <div class="has-text-centered">
      <button
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        @click="makeLockerDelivery"
      >
        {{ $t("lockerDelivery.deliver") }}
      </button>
    </div>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";

export default {
  props: ["locker"],

  mixins: [common, mask],

  data() {
    return {
      isLoading: false,
      client: {
        personalInfo: {
          name: "",
          personalId: "",
          email: "",
          cellphone: "",
          wheelchairUser: false
        },
        sendEmail: true,
        sendSMS: true
      },
      courier: {
        personalInfo: {
          name: "",
          personalId: "",
          email: "",
          cellphone: ""
        },
        sendEmail: true,
        sendSMS: true
      },
      deliveryId: "",
      observations: "",
      internalObservations: "",
      openDoorNow: true,
      warnClientNow: true,

      // aux fields
      clientPersonalId: "",
      clientCellphone: "",

      courierPersonalId: "",
      courierCellphone: ""
    };
  },

  methods: {
    makeLockerDelivery() {
      if (this.locker.lockerInfo.hasCourier) {
        this.makeLockerDeliveryWithCourier();
      } else {
        this.makeLockerDeliveryWithoutCourier();
      }
    },

    makeLockerDeliveryWithCourier() {
      this.isLoading = true;
      this.$store
        .dispatch("makeLockerDeliveryWithCourier", {
          lockerId: this.locker._id,
          client: this.client,
          courier: this.courier,
          deliveryId: this.deliveryId,
          observations: this.observations
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("get-lockers");
            this.$parent.$parent.close();
            this.$buefy.toast.open({
              message: this.$t("common.success"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    makeLockerDeliveryWithoutCourier() {
      this.isLoading = true;
      this.$store
        .dispatch("makeLockerDeliveryWithoutCourier", {
          lockerId: this.locker._id,
          client: this.client,
          deliveryId: this.deliveryId,
          observations: this.observations,
          openDoorNow: this.openDoorNow,
          warnClientNow: this.warnClientNow
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("get-lockers");
            this.$parent.$parent.close();
            this.$buefy.toast.open({
              message: this.$t("common.success"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  watch: {
    clientPersonalId(value) {
      this.client.personalInfo.personalId = value;
    },
    clientCellphone(value) {
      this.client.personalInfo.cellphone = value;
    },
    courierPersonalId(value) {
      this.courier.personalInfo.personalId = value;
    },
    courierCellphone(value) {
      this.courier.personalInfo.cellphone = value;
    }
  }
};
</script>
